import { render, staticRenderFns } from "./0001.vue?vue&type=template&id=04352b40&scoped=true&"
import script from "./0001.vue?vue&type=script&lang=js&"
export * from "./0001.vue?vue&type=script&lang=js&"
import style0 from "./0001.vue?vue&type=style&index=0&id=04352b40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04352b40",
  null
  
)

export default component.exports